import { Text, Tooltip, Group, Input } from '@cowbell/ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import {
  AffectedProductStatus,
  SpotlightProduct,
  RowState,
} from './spotlightDetails.types';
import { usePersona } from '../../../components/hooks/usePersona';
import { SpotlightUserAccessMode } from '../getSpotlightUserAccessMode';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../config/growthbook';

interface CurrentVersionColumnProps {
  persona: ReturnType<typeof usePersona>;
  status: AffectedProductStatus;
  product: SpotlightProduct;
  rowState: RowState;
  onVersionChange: (productName: string, value: string) => void;
  userAccessMode: SpotlightUserAccessMode;
}

const CurrentVersionColumn = (props: CurrentVersionColumnProps) => {
  const {
    persona,
    status,
    product,
    rowState,
    onVersionChange,
    userAccessMode,
  } = props;
  const isSpotlightV2PgSource = useFeatureIsOn(
    FEATURE_FLAG_KEYS.SPOTLIGHT_V2_PG_SOURCE
  );
  let declinedReason = product.declinedReason;
  let customerVersion = product.customerVersion;

  if (isSpotlightV2PgSource) {
    declinedReason = product.statusReason;
    customerVersion = product.customerVersion;

    if (rowState.status !== undefined) {
      customerVersion = rowState.customerVersion;
    }
  }

  if (userAccessMode === 'readonly') {
    return (
      <Text size="md" fw={500}>
        {customerVersion || '--'}
      </Text>
    );
  }

  if (persona.isInsured) {
    if (
      [
        AffectedProductStatus.UNPATCHED,
        AffectedProductStatus.DECLINED,
      ].includes(status)
    ) {
      return (
        <Group gap="xs" justify="space-between" align="center" wrap="nowrap">
          <Input
            w="100%"
            placeholder="e.g. 16.0.5044.1000"
            value={rowState.customerVersion}
            onChange={(event) =>
              onVersionChange(product.name, event.currentTarget.value)
            }
            error={status === AffectedProductStatus.DECLINED}
          />
          {status === AffectedProductStatus.DECLINED && declinedReason && (
            <Tooltip label={declinedReason} color="red">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                color="var(--mantine-color-red-6)"
              />
            </Tooltip>
          )}
        </Group>
      );
    }

    return (
      <Text size="md" fw={500}>
        {customerVersion || '--'}
      </Text>
    );
  }

  if (
    status === AffectedProductStatus.PATCHED ||
    status === AffectedProductStatus.DECLINED ||
    status === AffectedProductStatus.NOT_APPLICABLE
  ) {
    return (
      <Group gap="xs" justify="space-between" align="center" wrap="nowrap">
        <Text size="md" fw={500}>
          {customerVersion || '--'}
        </Text>
        {status === AffectedProductStatus.DECLINED && (
          <Tooltip label={declinedReason} color="red">
            <FontAwesomeIcon
              icon={faCircleExclamation}
              color="var(--mantine-color-red-6)"
            />
          </Tooltip>
        )}
      </Group>
    );
  }

  return (
    <Input
      w="100%"
      placeholder="e.g. 16.0.5044.1000"
      value={rowState.customerVersion}
      onChange={(event) =>
        onVersionChange(product.name, event.currentTarget.value)
      }
    />
  );
};

export default CurrentVersionColumn;
